interface Props {
  readonly value: string;
  readonly onChange: (icon: string) => void;
}

/**
 * A fixed set, not a free-text field or an upload.
 *
 * These render at 16px in the Windows tray and on a counter panel at
 * arm's length. Letting an admin paste anything guarantees somebody
 * picks something unreadable, and the first time anyone notices is a
 * site saying they cannot tell the tabs apart.
 */
const ICONS: readonly (readonly [string, string])[] = [
  ['ti-clipboard-list', '\u2630'],
  ['ti-tool', '\u2692'],
  ['ti-device-desktop', '\u25A3'],
  ['ti-users', '\u25CF'],
  ['ti-tag', '\u25C6'],
  ['ti-shield', '\u2756'],
  ['ti-truck', '\u25AC'],
  ['ti-cash', '\u25CE'],
  ['ti-alert', '\u26A0'],
  ['ti-calendar', '\u25A6'],
];

export const IconPicker = ({ value, onChange }: Props) => (
  <div className="iconGrid">
    {ICONS.map(([id, glyph]) => (
      <button
        key={id}
        type="button"
        className={id === value ? 'iconOpt on' : 'iconOpt'}
        onClick={() => onChange(id)}
        aria-label={id}
      >
        {glyph}
      </button>
    ))}
  </div>
);

export const glyphFor = (icon: string): string =>
  ICONS.find(([id]) => id === icon)?.[1] ?? '\u2630';
